import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-other-participant-modal-dialog .app-modal {
  width: 516px;
}

.inspection-other-participant-modal-header-title-block {
  gap: ${dt('inspectionOtherParticipantModal.header.gap')};
}

.inspection-other-participant-modal-subtitle {
  font-size: ${dt('inspectionOtherParticipantModal.header.subtitle.fontSize')};
  line-height: ${dt('inspectionOtherParticipantModal.header.subtitle.lineHeight')};
  font-weight: ${dt('inspectionOtherParticipantModal.header.subtitle.fontWeight')};
  color: ${dt('inspectionOtherParticipantModal.header.subtitle.color')};
}

.inspection-other-participant-modal-title {
  font-size: ${dt('inspectionOtherParticipantModal.header.title.fontSize')};
  line-height: ${dt('inspectionOtherParticipantModal.header.title.lineHeight')};
  font-weight: ${dt('inspectionOtherParticipantModal.header.title.fontWeight')};
  color: ${dt('inspectionOtherParticipantModal.header.title.color')};
  margin: 0;
}

.inspection-other-participant-modal-edit-link {
  border: 0;
  background: transparent;
  padding: 0;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  color: ${dt('inspectionOtherParticipantModal.editLink.color')};
}`;
